import Vue from 'vue'
import Vuex from 'vuex'
// import login from './login'
// vuex持久化插件
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    
  },
  state: {
    userInfo:{
    },
    
    shortToken: '0',
    // 长token
    longToken: '',
    // 心跳：服务器时间-本地时间
    serverTimeSiffer: '',
    certificationStatus:""
  },
  getters: {
    // 获取服务器时间 差值 + 服务器时间
    getServerTime: state => {
      return +state.serverTimeSiffer + new Date().getTime()
    }
  },
  mutations: {
    memoryData(state, items) { //存储数据通用方法
      for(var i in items){
        state[i] = items[i]
      }
    },

    setShortToken (state, payload) {
      state.shortToken = payload
    },
    setLongToken (state, payload) {
      state.longToken = payload
    },
    
    setUserInfo (state, payload){
			state.userInfo = payload;
		},
    setUserStatus (state, payload){
      state.certificationStatus = payload;
    },
  },
  actions: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js